

















import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import Card from '@/components/Card.vue';
import dayjs, {Dayjs} from 'dayjs';

@Component({
    components: {Card}
})
export default class extends Vue {
    @Prop() value!: Dayjs;
    @Prop() MonthToggle!: boolean;
    year = dayjs().year();
    month = dayjs().month();
    thisYearMonths = new Array(this.month + 1).fill(1).map((a, index) => {
        return dayjs().month(index);
    });

    SelectMonth(value: Dayjs) {
        this.$emit('update:value', value);
    }

    xxx() {
        console.log('xxx');
        this.$emit('update:MonthToggle',false)
    }




}
